module.exports = __webpack_public_path__ + "img/vertical_3_5_9005.7cc2cf72.png";